<template>

        <result-detail
                v-if="isResult"
                :dosageDay="dosageDay"
                :type="type"
                :isAdult="isAdult"
                :selectedItems="selectedItems"
                :selectedCount="selectedCount"
                :maxPrice="maxPrice"
                :exceedPrice="exceedPrice"
                :myPayment="myPayment"
                :ratio="ratio"
                :etcPrice="etcPrice"
                :maxFund="maxFund"
                :diseaseType="diseaseType"
                :autoInjector="autoInjector"
                @onClose="onCloseResultDetail"
            />
        <div name="calculate-result" class="calculate-result" ref="mainScrollDiv" v-else>
            
            <search-modal 
                v-if="isSearchModal && !isResult"
                @onClose="onSearchModalClose"
                @selectItem="selectItem"
                @deleteItem="deleteItem"
                :selectedIdList="selectedIdList"
                :selectedCount="selectedCount"
                :autoInjector="autoInjector"
                :isAdult="isAdult"
                :allPayment="allPayment"
            /> 
            <confirm-modal 
                :title="'안내'"
                :text1="`현재 계산기에는 ${convertTypeToString(type)}의 제품이 선택되어 있습니다. 동일 품목 내에서만 계산이 가능합니다.`"
                :text2="'계속 진행하시면 기존 선택 내역이 초기화됩니다. 그래도 계속 진행하시겠습니까?'"
                @onYes="onConfirmModalYes"
                @onCancel="onConfirmModalCancel"
                v-if="isConfirmModal"
            />
            <div class="row" style="justify-content: space-between;">
                <div style="display: flex;justify-content: flex-start;align-items: center;">
                    <img @click="back" src="../../../assets/arrow_back.png" style="margin-right: 27px; width: 22px; cursor: pointer;"/>
                    <span class="header-text" >당뇨 소모성재료 계산</span>
                </div>

                <!-- <div class="custom-button-1">
                    고객센터 문의
                </div> -->
            </div>
            <!-- <text-label 
                :text="'품목 선택'"
                :isDefault="true"
                style="margin-top: 34px;"
            /> -->
            <!-- <div class="center-row" >
                <div class="button-black" v-if="type === 1">전극</div>
                <div class="button-white" @click="typeChange(1)" v-else>전극</div>
                <div class="button-black" v-if="type === 0">일반 소모성재료</div>
                <div class="button-white" @click="typeChange(0)" v-else>일반 소모성재료</div>
            </div> -->
            <text-label 
                :text="'처방일수'"
                :isDefault="true"
            />
            <input v-model="dosageDay" 
                inputmode="numeric" 
                v-focus-background
                style="background-color: var(--Gray-20, #F3F5F8); margin-bottom: 7px;"
                ref="dosageDay"
                class="input-big"
                maxlength="8"
                placeholder="숫자만 입력"
                :disabled="type === 2 || type === 3 || type === 6 || allPayment"
            />
            <span class="waring-text"  v-if="type === 1 && !allPayment">전극 - 최대 <span style="color: #184FA1">100일</span>까지 가능</span>
            <span class="waring-text"  v-if="type === 0 && !allPayment">일반 소모성재료 - 최대 <span style="color: #184FA1">180일</span>까지 가능</span>
            <span class="waring-text"  v-if="type === 3 && !allPayment">관리기기 - <span style="color: #184FA1">12개월</span> 기준으로 자동 입력됩니다</span>
            
            <div style="display: flex; margin-top: 8px;">
                <check-box 
                    :checked="allPayment"
                    @onClick="checkAllPayment"
                />
                <span class="all-payment-text">전액구매</span>
            </div>
            <span class="waring-text" style="margin-top: 8px;">공단 지원금이 적용되지 않아 본인 부담금 100%로 처리됩니다.</span>

            <div class="line" ></div>
            <div class="center-row" style="margin-top: 16px;">
                <text-label 
                    :text="'제품정보'"
                    :isDefault="true"
                />
                <button class="search-all-button" @click="onResultDetail" v-if="isResultButton">결과보기</button>
                <button class="search-all-button inactive" v-else>결과보기</button>
            </div>
            <div class="search-area" >
                <div
                    class="box"
                    @click="searchModalOpen"
                >
                    제품명 또는 카테고리명 입력
                </div>
            </div>        
            
            <div v-if="selectedItems.length > 0" style="margin-top: 8px;padding-bottom: 50px;width: 100%;" >
                <div class="selected-item-box" v-for="(item, index) in selectedItems" :key="index">
                    <img src="../../../assets/result_card_close.png" class="delete-item" @click="deleteItem(item)"/>
    
                    <img class="item-image" :src="item.imageUrl" />
                
                    <div class="col">
                        <span class="search-item-name2">{{ item.name }}</span>
                        <div class="row" style="margin-top: 8px;width: 225px;">
                            <span class="category-text">{{ convertCategoryToString(item.category) }} | </span> 
                            <span :class="!isSelfPaymentCategory(item.category) ? 'price-text-cancel': 'price-text'" style="margin-left: 4px;">{{ setComma(item.price)}} 원</span>    
                        </div>
                        <div class="row" style="width: auto; justify-content:  flex-start; padding: 4px 8px;box-sizing: border-box; margin-top: 8px;background: var(--Gray-20, #F3F5F8);border-radius: 6px; width: 225px;" v-if="!isSelfPaymentCategory(item.category) && !allPayment">
                            <span class="tag">{{ adultSaleCheck(item) }}</span><span class="red">{{ ratioCheck(item) }}</span><span class="price">{{ setComma(salePriceCheck(item)) }}원</span>
                        </div>
                        <div style="display: flex;justify-content: center;align-items: center; margin-top: 16px;">
                            <div class="box-button" @click="minus(index)">
                                -
                            </div>
                            <input
                                class="input-small"
                                inputmode="numeric" 
                                
                                maxlength="4"
                                v-model="selectedCount[index]" 
                                @input="inputCountChange(item, index)"/>     
                            <div class="box-button2" @click="plus(index)">
                                +
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; flex-direction: column; margin-top: 25px;" v-else>
                <span class="waring-text">💡이렇게도 검색 가능해요!<br>
                    제품명 (예시: 덱스콤, 케어센스, BD펜니들 등)<br>
                    카테고리 (예시: 채혈침, 펜니들, 검사지 등)</span>
                <span style="margin-top: 24px;" class="waring-text">
                    💡찾는 제품이 없다면 고객센터로 문의주세요!
                </span>
                <span style="margin-top: 8px;" @click="questionCenter" class="question-text">고객센터 문의하기</span>
                <!-- <div class="kakao-button" @click="kakaoClick">
                    <img src="../../../assets/kakao.png" style="width: 20px; margin-right: 8px;" />
                    <span>카카오 채팅상담</span>
                </div> -->
            </div>
            <div class="result">
                <div class="result-initial-box" v-if="!isDetailResultView" @click="expandResult">
                    <div class="arrow-button"    @click="expandResult">
                        펼치기
                        <img src="../../../assets/arrow_top3.png" class="arrow"  style="margin-left: 4px;"
                    />
                    </div>
                    
                    <div class="center-row" style="padding: 0 16px;" @click="expandResult">
                        <span class="result-price-text"><span style="color: var(--Blue-01_Primary-blue, #008DEF);">* </span>결제예정금액</span>
                        <span class="result-price-text">{{ setComma(exceedPrice + myPayment + etcPrice)}}원</span>
                    </div>
                </div>
                <div class="result-detail-box" v-else>
                    <div class="arrow-button" @click="expandResult">
                        접기 <img src="../../../assets/arrow_bottom3.png" class="arrow"   style="margin-left: 4px;"/>
                    </div>
                    <div class="result-detail-header"  @click="expandResult">
                        <span class="result-detail-gray-text">소모성재료 비용 계산</span>
                        <span class="result-detail-black-text" style="text-decoration: underline; cursor: pointer;" @click="onResultDetail" v-if="isResultButton">결과보기</span>
                    </div>
                    <div class="center-row" style="padding: 0 16px;margin-top: 16px;">
                        <span class="result-detail-black-text">총액</span>
                        <span class="result-detail-black-text">{{ setComma(maxPrice + etcPrice)}}원</span>
                    </div>
                    <div class="row" style="padding: 0 16px; margin-top: 16px;">
                        <span class="result-detail-black-text">공단 지원대상</span>
                    </div>
                    <div class="center-row" style="padding: 0 16px;margin-top: 8px;">
                        <span class="result-detail-gray-text">공단 부담 ({{ 100 - ratio }}%)</span>
                        <span class="result-detail-gray-text">{{ setComma(maxPrice - exceedPrice - myPayment)}}원</span>
                    </div>
                    <div class="center-row" style="padding: 0 16px;margin-top: 8px;">
                        <span class="result-detail-gray-text">본인 부담 ({{ ratio }}%)</span>
                        <span class="result-detail-gray-text">{{setComma(myPayment)}}원</span>
                    </div>
                    <div class="center-row" style="padding: 0 16px;margin-top: 16px;">
                        <span class="result-detail-black-text">남은 지원금</span>
                        <span class="result-detail-blue-text">{{maxFund - maxPrice > 0 ? setComma(maxFund - maxPrice) : 0}}원</span>
                    </div>
                    <div class="center-row" style="padding: 0 16px;margin-top: 8px;">
                        <span class="result-detail-black-text">초과 본인부담금 </span>
                        <span class="result-detail-red-text">{{ setComma(exceedPrice + etcPrice)}}원</span>
                    </div>
                    
                    <div class="center-row" style="padding: 0 16px;margin-top: 16px;">
                        <span class="result-price-text"><span style="color: var(--Blue-01_Primary-blue, #008DEF);">* </span>결제예정금액</span>
                        <span class="result-price-text">{{ setComma(exceedPrice + myPayment + etcPrice)}}원</span>
                    </div>
                </div>
            </div>
            <div class="bottom-toast-alarm" v-if="isCountToastVisible" >
                <span>해당 제품은 최대 {{maxCount}}개까지만 구매 가능합니다</span>
                <span @click="onCountToastClose">X</span>
            </div>
        </div>
</template>

<script>
import { debounce } from 'lodash';
import axios from 'axios';
import Convert from '@/utilities/convert';
import TextLabel from '@/components/atoms/TextLabel';
import focusBackground from '@/components/directives/focusBackground';
import html2canvas from 'html2canvas'
import SearchModal from '@/components/modals/calculator/SearchModal';
import ConfirmModal from '@/components/modals/calculator/ConfirmModal';
import ResultDetail from '@/components/organisms/calculator/ResultDetail';
import CheckBox from '@/components/atoms/CheckBox';

export default {
    name: 'calculateResult',
    props: ['diseaseType', 'birth', 'autoInjector', 'isAdult', 'selectedAutoInjector'],
    data: function()
    {
        return {
            dosageDay: null,
            list: null,
            maxFund: 0,
            ratio: 0, // 본인부담비율
            myPayment: 0,
            maxPrice: 0,
            exceedPrice: 0,
            etcPrice: 0,  // 본부율 100% 구매 물품 따로 계산
            type: -1,
            selectedItems: [],
            selectedCount: [],
            isDetailResultView:false,
            keyword: '', 
            isFocused: true,
            isNoSearchList: false,
            isSearch: false,
            isSearchModal: false,
            selectedIdList: [],
            isConfirmModal: false,
            tempItem: null,
            isResultButton: false,
            isResult: false,
            isCountToastVisible: false,
            countTimerId: null,
            isCountToastVisible: false,
            maxCount: 0,
            allPayment: false
        }
    },  
    components: {
        TextLabel,
        SearchModal,
        ConfirmModal,
        ResultDetail,
        CheckBox
    },
    directives: {
        focusBackground
    },
    mounted: function()
    {
        if(this.diseaseType === 'NA')
        {
            this.allPayment = true;
        }
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
            "customLauncherSelector": ".custom-button-1",
            "hideChannelButtonOnBoot": true
        });
        this.topFunction();
        this.calMaxFund();

    },
    methods: {
        checkAllPayment: function()
        {            
            if(this.diseaseType === 'NA')
            {
                return;
            }

            this.allPayment = !this.allPayment;
            
            if(this.allPayment)
            {
                this.dosageDay = null;
                this.calMaxFund();
                this.countChange();
            }
            else
            {
                if(this.type === 3)
                {
                    this.dosageDay = 365;
                }
                this.maxFund = 0;
                this.ratio = 0;
                this.myPayment = 0;
                this.maxPrice = 0;
                this.exceedPrice = 0;
                this.etcPrice = 0;
            }


            /// 가격 계산
        },
        onCountToastClose: function()
        {
            this.countTimerId = null;
            this.isCountToastVisible = false;
            this.maxCount = 0;
        },
        showCountToastElement(maxCount) {
            this.maxCount = maxCount
            if (this.countTimerId) {
                clearTimeout(this.countTimerId);
            }
            this.isCountToastVisible = true;
            this.countTimerId = setTimeout(() => {
                this.countTimerId = null;
                this.isCountToastVisible = false;
                this.maxCount = 0;
            }, 4000); // 2초 후에 숨김
        },
        isSelfPaymentCategory: function(category)
        {
            // 기타, 인슐린 펌프는 공단 지원 없이 100% 본인부담
            return category === 7 || category === 11;
        },
        adultSaleCheck: function(item)
        {
            
            if(!this.isSelfPaymentCategory(item.category))
            {
                if(this.isAdult === true)
                {
                    return '19세 이상'
                }
                else
                {
                    return '19세 미만'
                }
            }
            
            return;

        },
        ratioCheck: function(item)
        {
            if(item.category === 3)
            {
                if(this.isAdult === true)
                {
                    return '-70%'
                }
                else
                {
                    return '-90%'
                }
            }
            else if(item.category === 8)
            {
                return '-70%'
            }
            else if(!this.isSelfPaymentCategory(item.category))
            {
                if(!this.isAdult && this.autoInjector)
                {
                    return '-70%'
                }
                return '-90%';
            }
            
            return;
        },
        salePriceCheck: function(item)
        {
            if(item.category === 3)
            {
                if(this.isAdult === true)
                {
                    return item.price * 0.3;
                }
                else
                {
                    return item.price * 0.1;
                }
            }
            else if(item.category === 8)
            {
                                    return item.price * 0.3;
            }
            else if(!this.isSelfPaymentCategory(item.category))
            {
                if(!this.isAdult && this.autoInjector)
                {
                    return item.price * 0.3;
                }
                return item.price * 0.1;
            }
            
            return;
        },
        onResultDetail: function()
        {
            this.isResult = true;
        },
        onCloseResultDetail: function()
        {
            this.isResult = false;
        },
        onConfirmModalYes: function()
        {

            this.dosageDay = null;
            this.list = null;
            this.maxFund = 0;
            this.ratio = 0;
            this.myPayment = 0;
            this.maxPrice = 0;
            this.exceedPrice = 0;
            this.etcPrice = 0;
            this.type = -1;
            this.selectedItems = [];
            this.selectedCount = [];
            this.selectedIdList = [];
            this.keyword = '';
            this.isResultButton = false;

            this.isConfirmModal = false;
        
            this.type = this.tempItem.type;
            
            const isDuplicate =this.selectedItems.some(existingItem => existingItem.id === this.tempItem.id);
            if(isDuplicate)
            {
                alert("이미 추가된 상품입니다.")
            }
            else
            {
                // document.body.style.overflowY = 'auto';
                if(this.type === 0 && this.dosageDay > 180)
                {
                    this.dosageDay = 180;
                }
                else if(this.type === 1 && this.dosageDay > 100)
                {
                    this.dosageDay = 100;
                }

                this.selectedItems.push(this.tempItem);
                this.selectedCount.push(1);
                this.selectedIdList.push(this.tempItem.id);
                this.isSearch = false;
                this.isNoSearchList = false;
            }
            this.tempItem = null;
            this.topFunction();
            // type 2, 6일때만 자동계산 
            if(this.type === 2 || this.type === 6)
            {
                this.countChange();
            }

            this.calMaxFund();

        },
        onConfirmModalCancel: function()
        {
            this.isConfirmModal = false;
            this.tempItem = null;;
        },
        onSearchModalClose: function()
        {
            this.isSearchModal = false;
        },
        searchModalClose: function()
        {
            this.isSearchModal = false;
        },
        searchModalOpen: function()
        {
            this.isSearchModal = true;
        },
        save: async function()
        {
            let _this = this;




            html2canvas(document.getElementById('calculate-result')).then(async canvas => {
                // _this.onSaveAs(canvas.toDataURL('image/png'), `contract.png`)      
                const blob = _this.dataURLToBlob(canvas.toDataURL('image/png'));
                const file = new File([blob], "contract.png", { type: "image/png" });
                // this.files.delegation_docs_file = file;
                // console.log(file);
                // https://d3mz0r05sqimo9.cloudfront.net/calculator/save
                
                    // this.$store.dispatch(Constant.SAVE_FILE, {file: file})
                    //     .then((res) => {

                    //     })
                    //     .catch((err) => {})
                    const url = `${process.env.API_DB_ROOT}/diabetes/upload`; 
                    const formData = new FormData();
                    formData.append("file", file)
                    const headers = {
                        "Content-Type": "multipart/form-data", // FormData를 사용할 때 필수
                        "secret": "soldoc-qazwsx123", // 필요 시 인증 토큰 추가
                    };

                    try {
                        // 3. 파일 업로드 요청
                        const response = await axios.put(url, formData, { headers });

                        // console.log("Upload Success:", response.data);
                        return response.data;
                    } catch (error) {
                        console.error("Upload Failed:", error);
                        throw error;
                    }

                    // Kakao.Share.sendDefault({
                    // objectType: "feed",
                    // content: {
                    // title: "이미지 공유",
                    // description: "데이터를 변환하여 카카오톡 공유하기",
                    // imageUrl: 'https://d3mz0r05sqimo9.cloudfront.net/calculator/save', // Data URL 사용
                    // link: {
                    //     mobileWebUrl: "https://d3mz0r05sqimo9.cloudfront.net/calculator/save",
                    //     webUrl: "https://d3mz0r05sqimo9.cloudfront.net/calculator/save",
                    // },
                    // },
                    // buttons: [
                    // {
                    //     title: "자세히 보기",
                    //     link: {
                    //     mobileWebUrl: "https://d3mz0r05sqimo9.cloudfront.net/calculator/save",
                    //     webUrl: "https://d3mz0r05sqimo9.cloudfront.net/calculator/save",
                    //     },
                    // },
                    // ],
                // });

                // try {
                //     await navigator.share({
                //         title: "파일 공유 예제",
                //         text: "이 파일을 공유합니다.",
                //         files: [file], // 파일 추가
                //     });
                //     console.log("파일 공유 완료!");
                //     } catch (err) {
                //     // alert("파일 공유 중 오류 발생:", err);
                // }
            })
        },
        dataURLToBlob:function (dataURL) {
            const binaryString = atob(dataURL.split(",")[1]);
            const array = [];
            for (let i = 0; i < binaryString.length; i++) {
                array.push(binaryString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/png" });
        },
        onSaveAs: function(uri, filename) {
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = uri;
            link.download= filename;
            link.click();
            document.body.removeChild(link);
        },
        reset: function()
        {
            if(!confirm("초기화 하시겠습니까?"))
            {   
                return;
            }
            this.isResultButton = false;
            this.dosageDay = null;
            this.list = null;
            this.maxFund = 0;
            this.ratio = 0;
            this.myPayment = 0;
            this.maxPrice = 0;
            this.exceedPrice = 0;
            this.type = -1;
            this.etcPrice = 0;
            this.selectedItems = [];
            this.selectedCount = [];
            this.selectedIdList = [];
            this.keyword = '';

            this.topFunction();
            this.calMaxFund();
        },
        onFocus: function()
        {
            this.isSearch = true;
            this.$refs.searchInput.focus();
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        middleMoveFunction: function() {
            document.body.scrollTop = 400; // For Safari
            document.documentElement.scrollTop = 400; // For Chrome, Firefox, IE and Opera
        }, 
        closeSearch: function()
        {
            this.$refs.searchInput.blur(); // Input 포커스 해제 -> 키패드 내려감
            this.keyword = '';
            // document.body.style.overflowY = 'auto';
            this.list = null;
            this.isNoSearchList = false;
            this.isSearch = false;
        },
        convertTypeToString: function(type)
        {
            if(type === -1)
            {
                return ''
            }
            else if(type === 0)
            {
                return '일반 소모성재료'
            }
            else if(type === 1)
            {
                return '연속혈당측정기'
            }
            else if(type === 2)
            {
                return '기타'
            }
            else if(type === 8)
            {
                return '기타'
            }
            else if(type === 3)
            {
                return '관리기기'
            }
            else if(type === 6)
            {
                return '인슐린 펌프'
            }
        },
        convertCategoryToString: function(category)
        {
            if(category === 0)
            {
                return '펜니들'
            }
            else if(category === 1)
            {
                return '혈당검사지'
            }
            else if(category === 2)
            {
                return '채혈침'
            }
            else if(category === 3)
            {
                return '연속혈당측정기'    
            }
            else if(category === 4)
            {
                return '펌프용 주사기'
            }
            else if(category === 5)
            {
               return '주사기'
            }
            else if(category === 6)
            {
                return '펌프용 주사바늘'
            }
            else if(category === 7)
            {
                return '기타'
            }
            else if(category === 8)
            {
                return '관리기기'
            }
            else if(category === 11)
            {
                return '인슐린 펌프'
            }
        },
        expandResult: function()
        {
            this.isDetailResultView = !this.isDetailResultView;
        },
        back: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('back')
        },
        typeChange: function(value)
        {
            if(!confirm("이전 내용은 초기화됩니다.\n 변경 하시겠습니까?"))
            {   
                return;
            }
            this.type = value;
            this.dosageDay = null;
            this.list = null;
            this.maxFund = 0;
            this.ratio = 0;
            this.myPayment = 0;
            this.maxPrice = 0;
            this.exceedPrice = 0;
            this.etcPrice = 0;
            this.selectedItems = [];
            this.selectedCount = [];
            this.keyword = '';

            this.topFunction();
            this.calMaxFund();


        },
        questionCenter: function()
        {
            window.open("https://solcon.channel.io/home", "_blank")
        },
        setComma: function(data)
        {
            return Convert.setComma(data);
        },
        selectItem: function(item, count)
        {
            if(count === undefined || count === null)
            {
                count = 1;
            }

            // type 교차선택시 리셋 모달 노출 
            if(this.type !== -1 && this.type !== item.type)
            {
                this.isConfirmModal = true;
                this.tempItem = item;
                return;
            }


            this.type = item.type;
            this.ratioChange();


            if(item.category === 8 && !this.allPayment)
            {
                this.dosageDay = 365;
            }
            
            const isDuplicate =this.selectedItems.some(existingItem => existingItem.id === item.id);
            const index = this.selectedItems.findIndex(existingItem => existingItem.id === item.id);
            if(isDuplicate)
            {
                this.selectedCount[index] = count;
                // alert("이미 추가된 상품입니다.")
            }
            else
            {
                // document.body.style.overflowY = 'auto';

                if(this.type === 0 && this.dosageDay > 180)
                {
                    this.dosageDay = 180;
                }
                else if(this.type === 1 && this.dosageDay > 100)
                {
                    this.dosageDay = 100;
                }

                this.selectedItems.push(item);
                this.selectedCount.push(count);
                this.selectedIdList.push(item.id);
                this.isSearch = false;
                this.isNoSearchList = false;

                if(this.isSelfPaymentCategory(item.category))
                {
                    this.countChange();
                    this.calMaxFund();
                }

                if(this.dosageDay > 0)
                {
                    this.calMaxFund();
                    this.countChange();
                }

                if(this.allPayment)
                {
                    this.calMaxFund();
                    this.countChange();
                }
            }
            
        },
        deleteItem: function(item) {

            const index = this.selectedIdList.findIndex(existId => existId === item.id);
            this.selectedCount.splice(index, 1);
            this.selectedIdList.splice(index, 1);
            this.selectedItems.splice(index, 1);
            
            if(this.dosageDay > 0)
            {
                this.calMaxFund();
                this.countChange();
            }

            if(this.selectedItems.length === 0)
            {
                this.type = -1;
            }
        },
        plus: function(index)
        {
            if (this.selectedCount[index] === null) {
                this.$set(this.selectedCount, index, 1); // Vue 2: 반응형 업데이트
            } else {

                if(this.isNumberStrict(Number(this.selectedCount[index])))
                {
                    this.$set(this.selectedCount, index, Number(this.selectedCount[index]) + 1);
                }
                else
                {
                    this.$set(this.selectedCount, index, 1);
                }
            }
            if(this.selectedItems[index].maxCount !== null)
            {
                if(this.selectedItems[index].maxCount < this.selectedCount[index])
                {
                    this.$set(this.selectedCount, index, Number(this.selectedItems[index].maxCount));
                    this.showCountToastElement(this.selectedItems[index].maxCount);
                }
            }


            if(this.isSelfPaymentCategory(this.selectedItems[index].category))
            {
                this.countChange();
            }

            if(this.allPayment)
            {
                this.calMaxFund();
                this.countChange();
            }

            if(this.dosageDay > 0 )
            {
                this.calMaxFund();
                this.countChange();
            }
        },
        isNumberStrict: function (value) {
            return typeof value === 'number' && !Number.isNaN(value);
        },
        minus: function(index) {

            if (this.selectedCount[index] > 0) {
                this.$set(this.selectedCount, index, Number(this.selectedCount[index]) - 1); // Vue 2: 반응형 업데이트
            } else {
                this.$set(this.selectedCount, index, 0); // 값이 0보다 작아지지 않도록 방지
            }

            if(this.allPayment)
            {
                this.calMaxFund();
                this.countChange();
            }

            if(this.dosageDay > 0)
            {
                this.calMaxFund();
                this.countChange();
            }

            if(this.isSelfPaymentCategory(this.selectedItems[index].category))
            {
                this.countChange();
            }
        },
        fetchSearchResults: async function(query)
        {

            // this.middleMoveFunction();
            this.onFocus()
            // this.$refs.searchInput.focus()

            console.log(`Searching for: ${query}`);
            if(query !== '')
            {
                try {
                    
                    const url = `${process.env.API_DB_ROOT}/diabetes/item/search/${this.type}/${query}`;                   
                    const response = await axios.get(url);
        
                    console.log("response >>", response.data)     
                    this.list = response.data.data;
                    if(this.list.length === 0 || this.list === null)
                    {
                        this.isNoSearchList = true;
                    }
                    else
                    {
                        this.isNoSearchList = false;
                    }

                    // document.body.style.overflowY = 'hidden';

                } catch(err) {
                    this.isSearch = false;
                    this.isNoSearchList = false;
                    console.log("Error >>", err);
                    // document.body.style.overflowY = 'auto';
                }
                
            }
            else
            {
                this.isSearch = false;
                this.isNoSearchList = false;
                this.list = null;
            }


        },
        onInput: debounce(function (event) {
            this.fetchSearchResults(event.target.value);
        }, 500),
        inputCountChange: function(item, index){
            if(item !== undefined && index !== undefined)
            {
                 if(item.maxCount !== null)
                {
                    if(item.maxCount < this.selectedCount[index])
                    {
                        this.$set(this.selectedCount, index, Number(item.maxCount));
                        this.showCountToastElement(item.maxCount);
                    }
                }
            }
            
            if(this.isSelfPaymentCategory(item.category))
            {
                this.countChange();
            }

            if(this.allPayment)
            {
                this.calMaxFund();
                this.countChange();
            }

            if(this.dosageDay > 0)
            {
                this.calMaxFund();
                this.countChange();
            }

        },
        countChange: function()
        {
            this.maxPrice = 0;
            this.etcPrice = 0;

            for(let i = 0; i < this.selectedItems.length; i++)
            {
                if(this.isSelfPaymentCategory(this.selectedItems[i].category))
                {
                    this.etcPrice += this.selectedItems[i].price * Number(this.selectedCount[i]);
                }
                else
                {
                    this.maxPrice += this.selectedItems[i].price * Number(this.selectedCount[i]);
                }
            }
            this.myPayment = 0;
            this.exceedPrice = 0;

            if(this.maxPrice > this.maxFund)
            {
                this.exceedPrice = this.maxPrice - this.maxFund;
                this.myPayment = this.maxFund * (this.ratio / 100);
            }
            else
            {
                this.myPayment = this.maxPrice * (this.ratio / 100);
            }

            if(this.maxPrice > 0 || this.etcPrice > 0)
            {
                this.isResultButton = true;
            }
            else 
            {
                this.isResultButton = false;
            }
            
        
        },
        ratioChange: function()
        {
            if(this.type === 0) // 일반
            {            
                // 일반 
                if(this.isAdult)
                {
                    const basePrice = 2500;
                    this.ratio = 10;
                }
                else
                {
                    if(this.autoInjector)
                    {
                       
                        const basePrice = 4500;
                        this.ratio = 30;
                    }
                    else
                    {
                        const basePrice = 2500;
                        this.ratio = 10;
                    }
                }
            }
            else if(this.type === 3)
            {
                const basePrice = 10000;
                this.ratio = 30;
            }
            else  // 전극
            {
                if(this.isAdult)
                {
                    const basePrice = 10000;
                    this.ratio = 30;
                }
                else
                {
                    this.ratio = 10;
                    if(this.autoInjector)
                    {
                        const basePrice = 11000;
                    }
                    else
                    {
                        const basePrice = 10000;
                    }
                }
            }
        },
        calMaxFund: function()
        {
            if(this.allPayment)
            {
                this.maxFund = 0;
                this.ratio = 0;
                this.countChange();
                return;
            }


            if(this.type === 0) // 일반
            {            
                // 일반 
                if(this.isAdult)
                {
                    const basePrice = 2500;
                    this.ratio = 10;
                    this.maxFund = this.dosageDay * basePrice;
                }
                else
                {
                    if(this.autoInjector)
                    {
                       
                        const basePrice = 4500;
                        this.ratio = 30;
                        this.maxFund = this.dosageDay * basePrice;
                    }
                    else
                    {
                        const basePrice = 2500;
                        this.ratio = 10;
                        this.maxFund = this.dosageDay * basePrice;
                    }
                }
            }
            else if(this.type === 3)
            {
                this.dosageDay = 365;
                this.ratio = 30;
                this.maxFund = 840000;                
            }
            else if(this.type === 1)  // 전극
            {
                if(this.isAdult)
                {
                    const basePrice = 10000;
                    this.ratio = 30;
                    this.maxFund = this.dosageDay * basePrice;
                }
                else
                {
                    this.ratio = 10;
                    if(this.autoInjector)
                    {
                        const basePrice = 11000;
                        this.maxFund = this.dosageDay * basePrice;
                    }
                    else
                    {
                        const basePrice = 10000;
                        this.maxFund = this.dosageDay * basePrice;
                    }
                }
            }
            else
            {
                this.maxFund = 0;
                this.ratio = 0;   
            }
        },
        // isAdult: function (birth) {
            
        //     const today = new Date();
        //     const birthss = `${birth.substring(0, 4)}-${birth.substring(4,6)}-${birth.substring(6, 8)}`
        //     const birthDate = new Date(birthss);
        //     const birthYear = birthDate.getFullYear();
        //     const birthMonth = birthDate.getMonth();
        //     const birthDay = birthDate.getDate();

        //     const currentYear = today.getFullYear();
        //     const currentMonth = today.getMonth();
        //     const currentDay = today.getDate();

        //     let age = currentYear - birthYear;
            
        //     // 생일이 지나지 않았다면 나이를 1 감소
        //     if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        //         age--;
        //     }

        //     return age >= 19;
        // },
        kakaoClick: function()
        {
            window.open("https://pf.kakao.com/_xoDxeJG/chat", "_blank")
        },
    },
    watch: {
        dosageDay: function()
        {
            if(this.type === 0)
            {
                if(Number(this.dosageDay) > 180)
                {
                    alert("최대 처방일은 180일 입니다.")
                    this.dosageDay = Math.floor(this.dosageDay / 10);
                    return
                }
            }
            else if(this.type === 1)
            {
                if(Number(this.dosageDay) > 100)
                {
                    alert("최대 처방일은 100일 입니다.")
                    this.dosageDay = Math.floor(this.dosageDay / 10);
                    return
                }
            }
            else if(this.type === 3)
            {
                if(Number(this.dosageDay) !== 365 && this.dosageDay !== null)
                {
                    alert("처방일은 365일 입니다.")
                    this.dosageDay = 365;
                    return
                }
            }
            else 
            {
                if(Number(this.dosageDay) > 365)
                {
                    alert("최대 가능 처방일 이상입니다.")
                    this.dosageDay = Math.floor(this.dosageDay / 10);
                    return
                }
            }

            // 최대 지원금 계산
            if(Number(this.dosageDay) > 0)
            {   
                this.calMaxFund();
                this.countChange();
            }

            if(this.dosageDay === '' || this.dosageDay === null || Number(this.dosageDay) === 0 )
            {
                this.calMaxFund();
            }

          
        },
        type: function()
        {

            // 최대 지원금 계산
            if(this.dosageDay > 0)
            {
                this.calMaxFund();
                this.countChange();
            }
            if(this.type === 2 || this.type === 6)
            {
                this.dosageDay = null;   
            }
        }
    }
}
</script>

<style scoped>
    .calculate-result {
        width: 100%;
        box-sizing: border-box;
        padding: 14px 16px;
        position: relative;
    }
    @media (min-width: 600px) {
        .calculate-result {
            width: 600px;            
        }        
    }
    .question-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        cursor: pointer;
        text-underline-position: from-font;
    }
    .line {
        height: 8px;
        width: 100%;
        background: var(--Gray-sub-color1, #F3F5F8);
        margin-top: 19px;
        margin-bottom: 20px;
    }
    .row-column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .row {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: calc(90% - 90px);
    }
    .center-row {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
    }
    .header-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .all-payment-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        margin-left: 8px;
    }
    .button-white {
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        height: 54px;
        width: 49%;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .button-black {
        border-radius: 6px;
        background: #184FA1;
        height: 54px;
        width: 49%;
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .info-box {
        width: 100%;
        border-radius: 6px;
        background: var(--Blue-04_Light-blue, #E5F0FC);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        padding: 21px 8px 21px 8px;
        box-sizing: border-box;
    }
    .info-box-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
    }
    .search-area {
        position: relative;
        width: 100%;
    }
    .search-list {
        background: var(--Gray-00, #FFF);
        filter: drop-shadow(0px 2px 15px rgba(192, 192, 192, 0.62));
        width: 100%;
        height: 274px;
        overflow-x: hidden;
        overflow-y: auto;
        z-index: 999;
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .search-icon {
        position: absolute;
        z-index: 1;
        width: 22px;
        top: 13px;
        left: 8px;
        cursor: pointer;
    }
    .result {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0%);
        width: 100%;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
        border-top: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        border-left: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        border-right: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        transition: height 3s ease; /* 부드럽게 변하도록 설정 */
        z-index: 1;
    }

    .result-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .result-price-text {
        color: var(--Gray-100, #1E1E1E);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
    }
    .result-initial-box {
        height: 82px;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        flex-direction: column;
        box-sizing: border-box;
        padding-top: 8px;
    }
    .result-detail-box {
        height: 376px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        box-sizing: border-box;
        padding-top: 8px;
    }

    .arrow {
        width: 22px;
    }
    .arrow-button {
        width: 73px;
        cursor: pointer;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (min-width: 600px) {
        .result {
            width: 600px;            
        }        
    }
    .search-item {
        width: 100%;
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 8px 12px;
        box-sizing: border-box;
        margin-bottom: 2px;
        cursor: pointer;
    }
    .search-item-name {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

    }
    .search-item-name2 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: inline-block; /* 줄바꿈을 가능하게 하기 위해 block 또는 inline-block 설정 */
        word-break: break-word; /* 긴 단어를 줄바꿈 */
        overflow-wrap: break-word; /* 단어를 줄바꿈 */
        white-space: normal; /* 기본 줄바꿈 허용 */
    }
    .search-item-description {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .result-detail-header {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #D1D6DB;
        padding: 0 16px;
        box-sizing: border-box;
    }
    .result-detail-gray-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .result-detail-black-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .result-detail-red-text {
        color: var(--Semantic-01_Red, #FF000F);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .result-detail-blue-text {
        color: var(--Blue-01_Primary-blue, #008DEF);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .selected-item-box {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 12px;
        position: relative;
        border-bottom: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: #FFF;
        margin-bottom: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .delete-item {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 22px;
        cursor: pointer;
    }
    .waring-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .search-all-button {
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .close-icon {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 0px;
        z-index: 1;
        top: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .kakao-button {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.54px;
        border-radius: 6px;
        border: 1px solid var(--Gray-50, #A3AAB6);
        background: #FFE601;
        width: 155px;
        height: 40px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        cursor: pointer;
    }
    .input-small {
        width: 50px;
        height: 40px;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        box-sizing: border-box;
        text-align: center;
        border: 0;
        background: #FFF;
    }
    .box-button {
        width: 35px;
        height: 28px;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Pretendard;
        font-size: 25px;
        padding-bottom: 4px;
    }
    .box-button2 {
        width: 35px;
        height: 28px;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Pretendard;
        font-size: 25px;
        padding-bottom: 4px;
    }
    .inactive {
        border: 0;
        background: var(--gray-30-stroke, #E8EAEE);
        color: var(--gray-40-button-stroke, #D1D6DB);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .item-image {
        width: 88px;
        height: 88px;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 8px;
    }
    .box {
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
    }
    .category-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .price-text-cancel {
        color: var(--Gray-60, #6B7684);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .price-text {
        color: var(--Gray-100, #1E1E1E);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
     .tag {
        border-radius: 6px;
        background: #184FA1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px 4px;
        box-sizing: border-box;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .red {
        color: var(--Semantic-01_Orange, #FC7E2F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 4px;
    }
    .price {
        color: var(--Gray-100, #1E1E1E);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-left: 8px;
    }
    .bottom-toast-alarm {
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        height: 57px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        backdrop-filter: blur(2px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 32px);
        animation: fadeIn 0.5s forwards;
        cursor: pointer;
        z-index: 9999;
    }
     /* v-if를 사용할 때 사라질 때 애니메이션 효과 */
    .bottom-toast-alarm.v-leave-active {
        animation: fadeOut 0.5s forwards;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            /* transform: translateY(-10px); */
        }
        to {
            opacity: 1;
            /* transform: translateY(0); */
        }
    }

    /* 사라질 때 애니메이션 */
    @keyframes fadeOut {
        from {
            opacity: 1;
            /* transform: translateY(0); */
        }
        to {
            opacity: 0;
            /* transform: translateY(-10px); */
        }
    }

    @media (min-width: 600px) {
        .bottom-toast-alarm {
            width: 564px;            
        }        
    }

    .custom-button-1 {
        width: 56px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;              
        background: #184FA1;
        width: 114px;
        height: 34px;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/calculator/CalculateResult.vue